import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const SocialBehaviorQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[5].icon}
          categoryName={categories[5].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="小组讨论中，关于项目方向出现了严重分歧，气氛变得紧张。各方坚持不同的方案。你通常会如何应对这种情况？" 
          inputType="radio"
          options={[
            "A. 寻找一个折中方案让大家都接受",
            "B. 坚持自己的立场并努力说服他人",
            "C. 提出一个完全不同的第三方案，希望打破僵局",
            "D. 先退一步观察，等气氛缓和后再介入"
          ]}
          customOption={true}
          customValue={formData.conflictResolutionOther}
          onCustomChange={(value) => handleInputChange('conflictResolutionOther', value)}
          value={formData.conflictResolution}
          onChange={(value) => handleInputChange('conflictResolution', value)}
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[5].icon}
          categoryName={categories[5].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="回忆一次进入新环境（如新班级或学生组织）的经历。你如何建立新的联系？你是主动接触特定人群，还是让关系自然发展？描述你在头两周内你会采取的社交策略。" 
          value={formData.networkingStyle}
          onChange={(value) => handleInputChange('networkingStyle', value)}
          inputType="textarea"
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[5].icon}
          categoryName={categories[5].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="当面临多个紧急截止日期时（如这周日你面临三个截止日期：一份重要论文、一个小组项目演示和一个课外活动的计划书），时间明显不够用，你的典型反应是什么？" 
          subtitle="（可多选）"
          inputType="checkbox"
          options={[
            "A. 立刻写下任务清单并安排时间表，开始逐一推进；",
            "B. 先休息一会或逃避，然后等到最后一天集中爆发完成；",
            "C. 找小组成员或朋友讨论，请求协助或分担任务；",
            "D. 优先处理最重要/影响最大的一项，其他等完成后再想办法；",
            "E. 感到极度焦虑，短时间内无从下手，需要冷静下来后再行动；",
            "F. 直接放弃一部分，集中火力保证最重要任务做完"
          ]}
          value={formData.deadlineResponses}
          onChange={(values) => handleInputChange('deadlineResponses', values)}
        />
      );
    case 4:
      return (
        <QuestionCard 
          categoryIcon={categories[5].icon}
          categoryName={categories[5].name}
          questionNumber={4}
          totalQuestions={totalQuestions}
          title="在上述这种压力情况下，你的工作质量相比平时通常:" 
          inputType="radio"
          options={[
            "会提高",
            "差不多",
            "会降低"
          ]}
          value={formData.workQualityUnderPressure}
          onChange={(value) => handleInputChange('workQualityUnderPressure', value)}
        />
      );
    default:
      return null;
  }
};

export default SocialBehaviorQuestions;